import React from "react";
import { useGetTeamQuery } from "../features/team/teamApi";
import TeamMember from "./TeamMember";
import Error from "./ui/Error";
import Loading from "./ui/Loading";

export default function TeamMembers() {
  const { data: teamMembers, isLoading, isError, error } = useGetTeamQuery();

  // deciding what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && teamMembers?.length === 0) {
    content = <div>No team members found!</div>;
  } else if (!isLoading && !isError && teamMembers?.length > 0) {
    content = teamMembers.map((teamMember) => {
      return <TeamMember key={teamMember.id} teamMember={teamMember} />;
    });
  }
  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
